import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AccountSmtpsService {
  private apiUrl = environment.apiURL + 'account-smtps';

  constructor(private http: HttpClient) {}

  getSmtps(params: any = {}): Observable<any> {
    return this.http.get(this.apiUrl, { params });
  }

  getSmtp(reference: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/${reference}`);
  }

  createSmtp(body: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/new`, body);
  }

  updateSmtp(reference: string, body: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/${reference}/update`, body);
  }

  deleteSmtp(reference: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${reference}/delete`);
  }
}
